import { isUsuarioUsoMuto } from 'utils';
import { FOLHA_PONTO_OLD, PEDIDO_VOO, CALENDARIO_FERIADOS_ADMIN } from 'constants/modules';
import { isRoleAuditoriaNsir } from '../../../../helpers/auditoriaNsirPermission';
import { hasModuleConfiguration } from '../../../../helpers/moduleConfigurationPermission';
import { isAdmin, INSPETOR } from 'constants/role';

/**
 * Itens dinâmicos de Folha de Ponto para o menu lateral (formato legado: href).
 */
export const renderFolhaPonto = (authData, moduleConfigurations) => {
  if (isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(authData.role)) return [];

  const options = [];
  // if (hasModuleConfiguration(moduleConfigurations, authData, FOLHA_PONTO_OLD)) {
  //   options.push({
  //     title: 'Folha de Ponto (Antigo)',
  //     href: '/folha-pontos',
  //     show: true,
  //     key: 'inspecao',
  //   });
  // }

  options.push({
    title: 'Folha de Ponto',
    href: '/v2/folha-pontos',
    show: true,
    key: 'inspecao',
  });

  return options;
};

export const renderPedidoVoo = (authData, moduleConfigurations) => {
  const isCustomRole = isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(authData.role);
  const rolePermission = isAdmin(authData.role) || authData.role === INSPETOR;

  if (isCustomRole || !rolePermission) return [];

  const options = [];
  if (hasModuleConfiguration(moduleConfigurations, authData, PEDIDO_VOO, { allowNullUserId: true })) {
    options.push({
      title: 'Pedidos de Voo',
      href: '/v2/pedidos-voo',
      show: true,
      key: 'inspecao',
    });
  }

  return options;
};

export const renderCalendarioFeriadosAdmin = (authData, moduleConfigurations) => {
  const options = [];
  if (
    hasModuleConfiguration(moduleConfigurations, authData, CALENDARIO_FERIADOS_ADMIN, {
      allowNullUserId: true,
    })
  ) {
    options.push({
      title: 'Calendário Admin. & Gestão',
      href: '/v2/calendario-admin',
      show: true,
      key: 'recursosHumanos',
    });
  }

  return options;
};
